// extracted by mini-css-extract-plugin
module.exports = {"item":"SectionItems_item__nXR5y","subheading":"SectionItems_subheading__G8yvA"};